import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { supabase } from "../supabaseClient";
import TeamCard from "../components/TeamCard";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Leadership = () => {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);

  const staggerContainer = {
    hidden: { opacity: 1 },
    visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
  };

  const smoothSpringReveal = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  useEffect(() => {
    async function fetchAllStaff() {
      try {
        const { data, error } = await supabase
          .from("staff")
          .select("*")
          .order("priority", { ascending: true });

        if (error) throw error;
        setStaff(data || []);
      } catch (err) {
        console.error("Fetch error:", err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchAllStaff();
  }, []);

  return (
    <div className="leadership-page">
      <TopBar />
      <Navbar />
      <div className="team-card-system">
        <div className="team-inner">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
            className="team-header-block"
          >
            <h2 className="title-display">
              Our Full <br /> <span className="accent">Leadership</span>
            </h2>
          </motion.div>

          {loading ? (
            <div className="loading">Loading Team...</div>
          ) : (
            <div className="team-grid-layout">
              {staff.map((member) => (
                <TeamCard
                  key={member.id}
                  member={member}
                  variants={smoothSpringReveal}
                />
              ))}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Leadership;
